import Route from '@ember/routing/route'

export default class BookingExtensionRoute extends Route {}
